import React from 'react'
import PropTypes from 'prop-types'
import Toggle from './rate-limit-toggle'
import RangeSlider from '../../../../../components/form/range-slider'

const RateLimitRecord = ({
  active,
  type,
  defaultLimit,
  currentLimit,
  handleToggle,
  handleLimitChange
}) => {
  return (
    <div className='form-group'>
      <label className='col-sm-3 col-md-3 control-label'>
        Increase {type} rate-limit
      </label>
      <div className='col-sm-1 col-md-1'>
        <Toggle checked={active} onChange={handleToggle} />
      </div>
      {!active && (
        <div
          className='col-sm-3 col-md-3'
          style={{ fontSize: 14, verticalAlign: 'bottom' }}
        >
          (Default is {defaultLimit} per second)
        </div>
      )}
      {active && (
        <div
          className='col-xs-4 col-sm-4 col-md-4'
          style={{
            marginTop: 0,
            marginBottom: 0,
            marginLeft: 20,
            color: '#6F6F6F',
            verticalAlign: 'top'
          }}
        >
          <RangeSlider
            grid
            postfix=' per second'
            type='single'
            min={2}
            max={160}
            step={1}
            from={currentLimit}
            onChange={handleLimitChange}
          />
        </div>
      )}
    </div>
  )
}

RateLimitRecord.propTypes = {
  active: PropTypes.bool,
  type: PropTypes.string,
  defaultLimit: PropTypes.number,
  handleToggle: PropTypes.func,
  handleLimitChange: PropTypes.func,
  currentLimit: PropTypes.number
}

export default RateLimitRecord



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-rate-limits/components/rate-limit-record.js